<template>
  <div class="wall-honor-edit-container">
    <div class="title">
      荣誉证书
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/wallHonor' }"
            ><span class="dsadf"> 荣誉证书 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>编辑比赛荣誉证书</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div style="margin: -20px 0 20px">
      <el-button size="mini" @click="$router.back()">返回</el-button>
    </div>
    <el-card>
      <el-form
        ref="form"
        :model="formState"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="标题" label-width="10%" prop="title">
          <el-input
            v-model="formState.title"
            style="width: 50%"
            placeholder="输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" label-width="10%" prop="type">
          <el-radio-group v-model="formState.type">
            <el-radio label="1">比赛</el-radio>
            <el-radio label="2">证书</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="列表卡片默认图" label-width="10%">
          <MultipleUploadSWithDragort
            :uploadedList.sync="formState.demo_bgm"
            :uploadMaxLen="1"
            name="pic"
          >
          </MultipleUploadSWithDragort>
        </el-form-item>
        <el-form-item label="荣誉卡片背景" label-width="10%">
          <MultipleUploadSWithDragort
            :uploadedList.sync="formState.bgm"
            :uploadMaxLen="1"
            name="pic"
          >
          </MultipleUploadSWithDragort>
          <div class="tip" style="color: #86909c">
            推荐 xxx x xxxpx 的jpg
            <br />
            图形压缩工具>
            <a target="_blank" href="https://tinypng.com"
              >https://tinypng.com</a
            >
          </div>
        </el-form-item>
        <el-form-item label="描述字体颜色" label-width="10%">
          <el-input
            v-model="formState.label_color"
            placeholder="输入颜色值"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据字体颜色" label-width="10%">
          <el-input
            v-model="formState.value_color"
            placeholder="输入颜色值"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="handleCommit">提交</el-button>
    </el-card>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { getWallHonorDetail, editWallHonor, addWallHonor } from "@/api/honor";
import MultipleUploadSWithDragort from "@/components/MultipleUploadWithDragSort/index.vue";

export default {
  name: "WallHonorEdit",
  components: {
    MultipleUploadSWithDragort,
  },
  data() {
    return {
      id: null,
      labelPosition: "left",
      formState: {
        id: 0,
        type: "2",
        title: "",
        bgm: [],
        demo_bgm: [],
        label_color: "",
        value_color: "",
      },
    };
  },
  methods: {
    init() {
      this.id = this.$route.query.id;
      console.log("__init", this.id);
      if (this.id > 0) {
        getWallHonorDetail({
          id: this.id,
        }).then((resp) => {
          console.log("_getWallHonorDetail", resp);
          let data = resp.data.data;
          this.formState = {
            ...data,
            bgm: [data.bgm],
            demo_bgm: [data.demo_bgm],
          };
        });
      }
    },
    handleCommit() {
      let formState = cloneDeep(this.formState);
      formState.bgm = formState.bgm[0];
      formState.demo_bgm = formState.demo_bgm[0];
      console.log("_commit", formState);
      if (formState.id) {
        editWallHonor({
          ...formState,
        }).then((res) => {
          console.log(res);
          if (res.data.result === 0) {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: "1200",
            });
            return;
          }
          if (res.data.result === 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: "1200",
            });
            setTimeout(() => {
              this.$router.push("/wallHonor");
            }, 1200);
          }
        });
      } else {
        const postData = cloneDeep(formState);
        delete postData.id;
        addWallHonor(postData).then((res) => {
          if (res.data.result === 0) {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: "1200",
            });
            return;
          }
          if (res.data.result === 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: "1200",
            });
            setTimeout(() => {
              this.$router.push("/wallHonor");
            }, 1200);
          }
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="less">
.imgbox {
  width: 188px;
  height: 188px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 5px;
  position: relative;
  .imgs {
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}
.wall-honor-edit-container {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
}
</style>
